Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Discussion3495901531",
  {"root":"Discussion3495901531--root","container":"Discussion3495901531--container","widgetHeader":"Discussion3495901531--widgetHeader","widgetText":"Discussion3495901531--widgetText"},
  "",
  12,
  "Discussion3495901531"
);

